// @ts-strict-ignore
import React, { useEffect, useState } from 'react';
import { getUserFlags } from 'common/report/queries/app-api/user-flags';
import { ChromeHeader } from 'common/widgets/chrome/chrome-header';
import { StarterBoardSurvey } from '../starter-board-feedback-modal';
import { StarterBoardActivatedModal } from '../starter-board-activated-modal';
import { StarterBoardModalType } from './types';
export const StarterBoardModal = (_ref: {
  userEmail?: string;
  projectId?: number;
  isOnStarterBoardWithData: boolean;
  projectUserCount?: number;
}) => {
  let {
    userEmail,
    projectId,
    isOnStarterBoardWithData,
    projectUserCount
  }: {
    userEmail?: string;
    projectId?: number;
    isOnStarterBoardWithData: boolean;
    projectUserCount?: number;
  } = _ref;
  const [modalType, setModalType] = useState<StarterBoardModalType | null>(null);
  const [dismissedModal, setDismissedModal] = useState<boolean>(false);
  const showOnboardingChecklist = () => {
    const chromeHeader = document.querySelector<ChromeHeader>("mp-chrome-header");
    chromeHeader === null || chromeHeader === void 0 || chromeHeader.update({
      isStarterBoardModalOpen: false
    });
  };
  const hideOnboardingChecklist = () => {
    const chromeHeader = document.querySelector<ChromeHeader>("mp-chrome-header");
    chromeHeader === null || chromeHeader === void 0 || chromeHeader.update({
      isStarterBoardModalOpen: true
    });
  };
  const dismissModal = () => setDismissedModal(true);
  const showModal = (type: StarterBoardModalType) => {
    hideOnboardingChecklist();
    setModalType(type);
  };
  useEffect(() => {
    if (isOnStarterBoardWithData && !dismissedModal) {
      getUserFlags().then(userFlags => {
        const showStarterBoardActivatedModal = projectUserCount < 10 && !userFlags.DISMISSED_STARTER_BOARD_MODAL;
        if (showStarterBoardActivatedModal) {
          showModal(StarterBoardModalType.ACTIVATED);
        } else if (!userFlags.HIDE_STARTER_BOARD_SURVEY && userFlags.VIEWED_STARTER_BOARD_WITH_DATA_COUNT > 7) {
          showModal(StarterBoardModalType.FEEDBACK_SURVEY);
        }
      });
    } else if (modalType) {
      setModalType(null);
      showOnboardingChecklist();
    }
  }, [isOnStarterBoardWithData, setModalType, dismissedModal, setDismissedModal]);
  switch (modalType) {
    case StarterBoardModalType.ACTIVATED:
      return <StarterBoardActivatedModal dismiss={dismissModal} />;
    case StarterBoardModalType.FEEDBACK_SURVEY:
      return <StarterBoardSurvey dismiss={dismissModal} userEmail={userEmail} projectId={projectId} />;
    default:
      return null;
  }
};